export default {
  setSelections(state, val) {
    state.selections = val.selections
  },

  setProviderOptions(state, val) {
    state.providers = val.providers
  }

}



// WEBPACK FOOTER //
// ./src/Adm/store/mutations.js